import numbro from 'numbro';

angular.module('wbServices').factory('locale',
  ['$window', '$location', 'users', 'd3locale', 'storage',
    function ($window, $location, users, d3locale, storage) {
      function setLocalStorageLanguage(language) {
        storage.setItem('language', language);
      }

      function setTransifexLanguage(language) {
        const locale = language === 'french' ? 'fr_CA' : 'en';
        try {
          window.Transifex.live.onReady(() => window.Transifex.live.translateTo(locale, true));
        } catch (error) {
          console.log('Transifex failed to load');
        }
      }

      function setNumbroCulture(language) {
        const locale = language === 'french' ? 'fr-CA' : 'en-US';
        numbro.culture(locale);
      }

      function setMomentLocale(language) {
        const locale = language === 'french' ? 'fr-ca' : 'en';
        moment.locale(locale);
      }

      function setD3Locale(language) {
        const locale = language === 'french' ? 'fr-ca' : 'en-us';
        d3locale.setLang(locale);
      }

      function setIntercomPreferredLanguage(language) {
        const preferredLanguage = language === 'french' ? 'French' : 'English';
        if (typeof Intercom === 'function') {
          Intercom('update', { preferred_language: preferredLanguage });
        }
      }

      this.currentLanguage = null;

      this.getLocale = () => {
        const locale = document.documentElement.lang || navigator.language || navigator.userLanguage || 'en';
        return locale.toLowerCase();
      };

      this.getPreferredLanguage = () => {
        if (users.isSignedIn()) {
          return users.getCurrentUser().language;
        }
        return storage.getItem('language');
      };

      // TODO: Rename and update across codebase. This is a terrible name for it, what does getCurrentLanguage even mean?
      this.getCurrentLanguage = () => {
        const queryStringFrench = ($location.search().lang === 'fr') || ($location.search().lang === 'fr-ca');
        const queryStringEnglish = ($location.search().lang === 'en');
        const browserLocale = this.getLocale();
        const preferredLanguage = this.getPreferredLanguage();

        // First two are explicitly conditions, last ones are a fallback
        if (queryStringFrench || preferredLanguage === 'french') {
          this.currentLanguage = 'french';
        } else if (queryStringEnglish || preferredLanguage === 'english') {
          this.currentLanguage = 'english';
        } else if (browserLocale.startsWith('fr')) {
          this.currentLanguage = 'french';
        } else {
          this.currentLanguage = 'english';
        }

        return this.currentLanguage;
      };

      this.isFrench = () => this.getCurrentLanguage() === 'french';

      this.setLanguage = (language, refresh = false) => {
        setLocalStorageLanguage(language);
        if (refresh) { location.reload(); }
        this.currentLanguage = language;
        setTransifexLanguage(language);
        setNumbroCulture(language);
        setMomentLocale(language);
        setD3Locale(language);
        setIntercomPreferredLanguage(language);
      };

      return this;
    },
  ]);
